import {
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_APPEND,
  SET_QUERY,
  CLEAR_SEARCH,
} from "./types";

const initialState = {
  query: "",
  results: [],
  totalResults: 0,
  page: 1,
  loading: false,
  error: null,
};

export default function searchReducer(state = initialState, action) {
  switch (action.type) {
    case SET_QUERY:
      return { ...state, query: action.payload };
    case SEARCH_REQUEST:
      return { ...state, loading: true, error: null, results: [], page: 1 };
    case SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload.results,
        totalResults: action.payload.totalResults,
        page: action.payload.page,
      };
    case SEARCH_APPEND:
      return {
        ...state,
        results: [...state.results, ...action.payload.results],
        page: action.payload.page,
      };
    case SEARCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_SEARCH:
      return initialState;
    default:
      return state;
  }
}
